<div class="w-full">
  @if (!isLoading) {
  <!-- Mêmes onglets que le reste de l'app (sélecteur segmenté du calendrier) :
       piste vert pâle, onglet choisi en blanc, libellé sur une seule ligne. -->
  <div role="tablist" class="flex rounded-pill bg-vw-surface-tint p-0.5">
    @for (tab of tabs; track tab; let i = $index) {
    <button type="button" role="tab" [attr.aria-selected]="activeTab === i" (click)="selectTab(i)"
      class="min-h-target min-w-0 flex-1 truncate whitespace-nowrap rounded-pill border px-2 text-center text-body-s leading-tight transition"
      [ngClass]="activeTab === i ? 'border-vw-line bg-vw-surface font-semibold text-vw-primary-ink' : 'border-transparent text-vw-muted'">
      {{ tab.label | translate: tab.labelPayload }}
    </button>
    }
  </div>
  }
  @if (isLoading) {
  <vw-skeleton-loader [width]="'100%'" [height]="'44px'" [borderRadius]="'2rem'"></vw-skeleton-loader>
  }

  <!-- Content projection for tab content -->
  @if (!isLoading) {
  <div class="mt-6">
    <ng-content></ng-content>
  </div>
  }
</div>
